/** Dependency-free so content modules can link to checkout without pulling server-function code. */
export const INTRO_PASS_CHECKOUT_PATH = "/membership-checkout?plan=pass";
export const ANNUAL_CHECKOUT_PATH = "/membership-checkout?plan=annual";
export const QUARTERLY_CHECKOUT_PATH = "/membership-checkout?plan=quarterly";

/**
 * Master switch for the ₹99 offers (3-day all-access pass and single-course
 * trial). While false, every CTA promotes Annual membership and the payment
 * functions refuse new pass/trial orders. Flip to true to reintroduce them.
 */
export const INTRO_OFFERS_ENABLED = false;

/** Where the primary "buy" CTA sends visitors right now. */
export const PRIMARY_CHECKOUT_PATH = INTRO_OFFERS_ENABLED ? INTRO_PASS_CHECKOUT_PATH : ANNUAL_CHECKOUT_PATH;
